import { AgCartesianChartOptions } from "ag-charts-community";

import { CHART_PADDING, CHART_SERIES_STROKE_WIDTH_NONE } from "../constants";

import { DEFAULT_BASE_CHART_CONFIG } from "@/components/UsageCharts/constants";

const noHoverBorderHighlight = {
  highlight: {
    highlightedItem: {
      strokeWidth: CHART_SERIES_STROKE_WIDTH_NONE,
    },
    unhighlightedItem: {
      strokeWidth: CHART_SERIES_STROKE_WIDTH_NONE,
    },
    highlightedSeries: {
      strokeWidth: CHART_SERIES_STROKE_WIDTH_NONE,
    },
  },
};

export const analyticsChartOverlayOptions: AgCartesianChartOptions["overlays"] = {
  noData: {
    enabled: false,
  },
};

const analyticsChartTooltipPosition = {
  anchorTo: "node" as const,
  placement: ["right", "left", "top", "bottom"] as ["right", "left", "top", "bottom"],
};

export const baseAnalyticsChartOptions: Partial<AgCartesianChartOptions> = {
  background: DEFAULT_BASE_CHART_CONFIG.background,
  legend: {
    enabled: true,
    item: {
      marker: {
        shape: "circle",
      },
    },
  },
  padding: CHART_PADDING,
  overlays: analyticsChartOverlayOptions,
  tooltip: {
    ...DEFAULT_BASE_CHART_CONFIG.tooltip,
    mode: "shared" as const,
    range: "nearest" as const,
    showArrow: true,
    position: analyticsChartTooltipPosition,
  },
  theme: {
    ...DEFAULT_BASE_CHART_CONFIG.theme,
    overrides: {
      ...DEFAULT_BASE_CHART_CONFIG.theme.overrides,
      bar: {
        series: {
          ...DEFAULT_BASE_CHART_CONFIG.theme.overrides?.bar?.series,
          ...noHoverBorderHighlight,
        },
      },
      line: {
        series: {
          ...DEFAULT_BASE_CHART_CONFIG.theme.overrides?.line?.series,
        },
      },
      pie: {
        series: {
          ...noHoverBorderHighlight,
        },
      },
    },
  },
};

/** Pie, donut, heatmap, treemap, and sunburst need single/exact tooltips — shared mode breaks them. */
export const baseNonCartesianAnalyticsChartOptions: Partial<AgCartesianChartOptions> = {
  background: DEFAULT_BASE_CHART_CONFIG.background,
  padding: CHART_PADDING,
  overlays: analyticsChartOverlayOptions,
  tooltip: {
    ...DEFAULT_BASE_CHART_CONFIG.tooltip,
    mode: "single" as const,
    range: "exact" as const,
    showArrow: true,
    position: analyticsChartTooltipPosition,
  },
  theme: baseAnalyticsChartOptions.theme,
};
